import DepartmentForm from '@app/components/apps/Departments/DepartmentForm';
import { BaseBreadcrumb, BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';
import { useHeader } from '@app/components/header/layouts/HeaderContext';

const CreateDepartmentPage = () => {
  const { setBreadcrumb, clearHeaderButtons } = useHeader();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Add Department');

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumbWithRender
        routes={[
          {
            path: '/departments',
            breadcrumbName: 'Departments',
          },
          {
            path: '/add-department',
            breadcrumbName: 'Add Department',
          },
        ]}
        style={{ marginBottom: '15px' }}
      />,
    );

    return () => {
      setBreadcrumb(currentBreadcrumName);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <DepartmentForm
          editable={true}
          pageTitle={'Create Department'}
          type={'create'}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default CreateDepartmentPage;
